import { size } from 'common/units';
import { useEffect, useState } from 'react';

const useMobile = () => {

    const [ isMobile, setMobile ] = useState(window.innerWidth < size.md);
    
    useEffect(() => {
      
      const handleResize = () => {
        setMobile(window.innerWidth < size.md);
      }
        
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
  
    }, [])
    
    return isMobile;

}

export default useMobile;